
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2, Sparkles } from 'lucide-react';

interface AnalysisFormProps {
  onSubmit: (prompt: string) => void;
  isLoading: boolean;
  isImageUploaded: boolean;
}

const AnalysisForm: React.FC<AnalysisFormProps> = ({ onSubmit, isLoading, isImageUploaded }) => {
  // Enhanced prompt that will be used for all analyses
  const fixedPrompt = "Analyze my book cover thoroughly. Be specific about what works and what doesn't work. Flag any technical issues like poor resolution, text spacing problems, inappropriate font choices, color clashing, or visual hierarchy problems. For fiction books, identify the genre signals and suggest typography that would better match the genre. For nonfiction, evaluate how clearly the subject is communicated. Provide direct, specific feedback on title placement, readability, and effectiveness. Give me clear, actionable suggestions to improve my cover's marketability.";

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(fixedPrompt);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-xl mx-auto px-4 animate-fade-in">
      <Button 
        type="submit" 
        className="w-full bg-gradient-to-r from-bookRed to-bookGold hover:from-bookGold hover:to-bookRed text-white font-bold py-3 rounded-lg transform hover:scale-105 transition-all duration-300 shadow-lg"
        disabled={isLoading || !isImageUploaded}
      >
        {isLoading ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            Analyzing Cover Magic...
          </>
        ) : (
          <>
            <Sparkles className="mr-2 h-5 w-5" />
            Critique My Cover!
          </>
        )}
      </Button>
    </form>
  );
};

export default AnalysisForm;
